var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60863 14.8406L4.86951 11.6855L6.60863 8.57977L8.34775 11.6855L6.60863 14.8406Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13024 14.8406L1.39111 11.6855L3.13024 8.57977L4.86936 11.6855L3.13024 14.8406Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60863 23.4203L4.86951 20.2651L6.60863 17.1594L8.34775 20.2651L6.60863 23.4203Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13024 23.4203L1.39111 20.2651L3.13024 17.1594L4.86936 20.2651L3.13024 23.4203Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34762 3.10575L7.85524 2.2265C6.97211 2.74975 6.1438 3.35556 5.38062 4.03331L6.60849 6.26088L8.34762 3.10575Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60843 25.7392L5.36755 27.9552C6.13005 28.6338 6.9578 29.2406 7.84055 29.7649L8.34761 28.8449L6.60843 25.7392Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73901 20.174V30.7279C11.6621 31.5465 13.7779 32 15.9999 32C22.8793 32 28.744 27.658 31.0047 21.5652L9.73901 20.174Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0047 21.5652C31.6479 19.8319 31.9999 17.9571 31.9999 16C31.9999 7.1635 24.8364 0 15.9999 0C13.7781 0 11.6621 0.453312 9.73901 1.27175V21.5653H31.0047V21.5652Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/BY.82203c5b.svg";
export { ForwardRef as ReactComponent };